import { useEffect, useRef, useState, type CSSProperties } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { ROUTES } from '@shared/config/routes'
import { ICON_HEIGHT, MENU_ITEMS } from './menuItems'
import './BottomMenu.css'

const isActive = (path: string, pathname: string) =>
  path === ROUTES.HOME ? pathname === ROUTES.HOME : pathname.startsWith(path)

/** Нижнее меню: плавающая панель, подсветка переезжает к активному разделу. */
const BottomMenu = () => {
  const location = useLocation()

  const activeIndex = MENU_ITEMS.findIndex(item =>
    isActive(item.path, location.pathname)
  )
  // На страницах вне меню (вкусы, пересчёт формы) подсветку прячем, но
  // оставляем на месте: иначе при возврате она приезжала бы из угла.
  const lastIndexRef = useRef(Math.max(activeIndex, 0))
  if (activeIndex >= 0) lastIndexRef.current = activeIndex

  // Первый кадр рисуем без перехода: иначе при открытии приложения подсветка
  // проезжала бы от первого пункта к текущему.
  const [isAnimated, setIsAnimated] = useState(false)
  useEffect(() => setIsAnimated(true), [])

  return (
    <div className="block-bottom-menu">
      <nav className="bottom-menu">
        <span
          className={`bottom-menu-pill ${isAnimated ? 'animated' : ''}`}
          style={{
            width: `${100 / MENU_ITEMS.length}%`,
            transform: `translateX(${lastIndexRef.current * 100}%)`,
            opacity: activeIndex >= 0 ? 1 : 0,
          }}
          aria-hidden
        />

        {MENU_ITEMS.map((item, index) => (
          <Link
            key={item.path}
            to={item.path}
            className={`bottom-menu-item ${index === activeIndex ? 'active' : ''}`}
          >
            <span
              className="bottom-menu-icon"
              style={
                {
                  width: item.width,
                  height: ICON_HEIGHT,
                  // Кавычки обязательны: Vite инлайнит SVG в data-URI, внутри
                  // которого остаются апострофы (fill='%23666666'). Без кавычек
                  // это невалидный url-токен — WebKit его отбрасывает и вместо
                  // иконки остаётся залитый прямоугольник.
                  maskImage: `url("${item.icon}")`,
                  WebkitMaskImage: `url("${item.icon}")`,
                  // Наклон отдаём в CSS переменной, а не в transform: иначе
                  // инлайновый стиль перебил бы анимацию нажатия.
                  '--icon-rotate': `${item.rotate ?? 0}deg`,
                } as CSSProperties
              }
              aria-hidden
            />
            <span className="bottom-menu-label">{item.label}</span>
          </Link>
        ))}
      </nav>
    </div>
  )
}

export default BottomMenu
